import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Grid } from '@mui/material';

const AddMeasurementsModal = ({ open, onClose, memberId, memberName, onSave }) => {
  const [measurements, setMeasurements] = useState({
    Weight: '',
    Chest: '',
    Stomach: '',
    LowerTier: '',
    Waist: '',
    Arm: '',
    Hip: '',
    Thigh: ''
  });

  const handleChange = (field) => (event) => {
    setMeasurements({
      ...measurements,
      [field]: event.target.value
    });
  };

  const handleSubmit = async () => {
    await onSave(memberId, measurements);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2
      }}>
        <Typography variant="h6" gutterBottom>
          Add Measurements for {memberName}
        </Typography>
        <Grid container spacing={2}>
          {Object.keys(measurements).map((field) => (
            <Grid item xs={12} sm={6} key={field}>
              <TextField
                fullWidth
                label={field}
                type="number"
                value={measurements[field]}
                onChange={handleChange(field)}
                InputProps={{
                  endAdornment: <Typography>{field === 'Weight' ? 'kg' : 'inch'}</Typography>
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>Save</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddMeasurementsModal;